(function () {
  const REVIEWS_ANCHOR_ID = 'product-reviews';

  function getHeaderHeight() {
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader?.offsetHeight) return stickyHeader.offsetHeight;

    const sectionHeader = document.querySelector('.section-header');
    if (sectionHeader?.offsetHeight) return sectionHeader.offsetHeight;

    const cssHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );
    return Number.isFinite(cssHeight) && cssHeight > 0 ? cssHeight : 80;
  }

  function forceRevealScrollTriggers(target) {
    const targetY = target.getBoundingClientRect().top + window.scrollY;

    document.querySelectorAll('.scroll-trigger').forEach((element) => {
      const elementY = element.getBoundingClientRect().top + window.scrollY;

      if (elementY <= targetY + 200) {
        element.classList.add('scroll-trigger--cancel');
        element.classList.remove('scroll-trigger--offscreen');
      }
    });

    const section = target.closest('.shopify-section');
    if (section) {
      section.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
        element.classList.remove('scroll-trigger--offscreen');
      });
    }
  }

  function findReviewsTarget(href) {
    const targetId = href ? href.slice(1) : REVIEWS_ANCHOR_ID;
    if (!targetId) return null;

    let target = document.getElementById(targetId);
    if (target) return target;

    if (targetId === REVIEWS_ANCHOR_ID) {
      const reviewsSection = document.querySelector('.shopify-section[id*="product_google_reviews"]');
      if (reviewsSection) {
        target = reviewsSection.querySelector('.section-anchor') || reviewsSection;
      }
    }

    return target;
  }

  function scrollToAnchor(target) {
    if (!target) return false;

    forceRevealScrollTriggers(target);

    const doScroll = () => {
      const headerHeight = getHeaderHeight();
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

      window.scrollTo({
        top: Math.max(top, 0),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });

      target.focus({ preventScroll: true });

      window.setTimeout(() => {
        window.dispatchEvent(new Event('scroll', { bubbles: true }));
      }, 300);
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(doScroll);
    });

    return true;
  }

  function handleGoogleRatingClick(event) {
    const link = event.target.closest('.google-rating__link');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    const target = findReviewsTarget(href);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    scrollToAnchor(target);
  }

  document.addEventListener('click', handleGoogleRatingClick);
})();
